import { useContext } from 'react'
import { __ } from '@wordpress/i18n';
import SbUtils from '../../Utils/SbUtils'
import FeedEditorContext from '../Context/FeedEditorContext'
import { default as FeedHeader } from '../TikTokPlugin/Feed/Header'
import PostsWrapper from '../TikTokPlugin/Feed/PostsWrapper'
import LoadMoreButton from '../TikTokPlugin/Feed/LoadMoreButton'
import ErrorNotice from '../TikTokPlugin/Misc/ErrorNotice'

const Preview = () => {

    const {
        editorFeedSettings,
        editorActiveDevice,
        editorFeedData,
        editorModerationMode,
        isPro
    } = useContext(FeedEditorContext),

        feedSettings = editorFeedSettings.feedSettings,
        sources = editorFeedData?.feedData?.sourcesList || [],
        headerData = sources.map(source => SbUtils.jsonParse(source?.info)),
        devices = ['mobile', 'tablet', 'desktop'],
        errors = editorFeedData?.feedData?.errors;


    const getPostsList = () => {
        let postsList = [...editorFeedData.feedData.posts];

        if (!isPro) {
            return postsList.splice(0, feedSettings.numPostDesktop)
        }
        switch (editorActiveDevice.device) {
            case 'tablet':
                return postsList.splice(0, feedSettings.numPostTablet)
            case 'mobile':
                return postsList.splice(0, feedSettings.numPostMobile)
            default:
                return postsList.splice(0, feedSettings.numPostDesktop)
        }

    }


    return (
        <section className='sb-customizer-preview' data-preview-device={editorActiveDevice.device}>
            <section className='sb-preview-wrapper sb-fs sb-tr-2'>
                {
                    editorModerationMode.moderationMode !== true &&
                    <>
                        <section className='sb-preview-devices-top sb-fs'>
                            <span className='sb-bold sb-text-tiny sb-dark2-text'>{__('Preview', 'sb-customizer')}</span>
                            <div className='sb-preview-devices-chooser'>
                                {
                                    devices.reverse().map(device => {
                                        return <button
                                            className='sb-preview-chooser-btn'
                                            data-device={device}
                                            key={device}
                                            data-active={editorActiveDevice.device === device}
                                            onClick={() => {
                                                editorActiveDevice.setDevice(device)
                                            }}
                                        >
                                            {SbUtils.printIcon(device)}
                                        </button>
                                    })
                                }
                            </div>
                        </section>

                        {errors && errors.length > 0 &&
                            <ErrorNotice
                                errors={errors}
                            />
                        }

                        <section
                            className='sb-feed-wrapper sb-fs'
                            id={"sb-tiktok-feeds-container-" + editorFeedData?.feedData?.feed_info?.id}
                        >
                            <section
                                className='sbtt-feed-container sb-fs'
                                data-layout={feedSettings.layout}
                                data-feed-template={feedSettings.feedTemplate}
                                data-post-style={feedSettings.postStyle}
                            >

                                <FeedHeader
                                    feedSettings={feedSettings}
                                    headerData={headerData}
                                    isPro={isPro}
                                    isFeedEditor={true}
                                />
                                <PostsWrapper
                                    feedSettings={feedSettings}
                                    headerData={headerData}
                                    posts={getPostsList()}
                                    editorActiveDevice={editorActiveDevice}
                                    isPro={isPro}
                                    isFeedEditor={true}
                                />
                                {
                                    isPro &&
                                    <LoadMoreButton
                                        feedSettings={feedSettings}
                                        feedId={editorFeedData?.feedData?.feed_info?.id}
                                        isFeedEditor={true}
                                    />
                                }

                            </section>
                        </section>
                    </>
                }
            </section>
        </section>
    );

}

export default Preview;